import { Routes, Route } from 'react-router';
import { lazy, Suspense } from 'react';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import DataDeletionPage from './pages/DataDeletionPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import { ApplicationProvider } from './features/application/hooks/useApplication';
import { SkeletonForm } from './components/ui/Skeleton';

const ApplicationLayout = lazy(() => import('./features/application/ApplicationLayout'));
const PhoneVerificationStep = lazy(() => import('./features/application/PhoneVerificationStep'));
const PersonalDetailsStep = lazy(() => import('./features/application/PersonalDetailsStep'));
const AcademicDetailsStep = lazy(() => import('./features/application/AcademicDetailsStep'));
const PreferencesStep = lazy(() => import('./features/application/PreferencesStep'));
const DocumentsStep = lazy(() => import('./features/application/DocumentsStep'));
const ReviewStep = lazy(() => import('./features/application/ReviewStep'));
const SuccessPage = lazy(() => import('./features/application/SuccessPage'));

const AdminDashboardLayout = lazy(() => import('./features/admin/AdminDashboardLayout'));
const AdminDashboardPage = lazy(() => import('./features/admin/AdminDashboardPage'));
const AdminApplicationsPage = lazy(() => import('./features/admin/AdminApplicationsPage'));
const AdminApplicationDetailPage = lazy(() => import('./features/admin/AdminApplicationDetailPage'));
const AdminUsersPage = lazy(() => import('./features/admin/AdminUsersPage'));

export default function App() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-bg flex items-center justify-center"><SkeletonForm /></div>}>
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/data-deletion" element={<DataDeletionPage />} />

        {/* Application */}
        <Route path="/apply" element={
          <ApplicationProvider>
            <ApplicationLayout />
          </ApplicationProvider>
        }>
          <Route index element={<PhoneVerificationStep />} />
          <Route path=":id/personal" element={<PersonalDetailsStep />} />
          <Route path=":id/academic" element={<AcademicDetailsStep />} />
          <Route path=":id/preferences" element={<PreferencesStep />} />
          <Route path=":id/documents" element={<DocumentsStep />} />
          <Route path=":id/review" element={<ReviewStep />} />
        </Route>
        <Route path="/apply/:id/success" element={<ApplicationProvider><SuccessPage /></ApplicationProvider>} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardLayout />}>
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="applications" element={<AdminApplicationsPage />} />
          <Route path="applications/:id" element={<AdminApplicationDetailPage />} />
          <Route path="users" element={<AdminUsersPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
